import { Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import * as _ from 'lodash';
import * as moment from 'moment';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { AddAttachmentDialogComponent } from '../../../../shared-components/add-attachment-dialog/add-attachment-dialog.component';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { GeneralConfirmationComponent } from '../../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { Attachment } from '../../../../shared-components/models/attachment.model';
import { ProfileService } from '../../../../shared-components/profile-table/profile.service';
import { SharedService } from '../../../../shared-components/shared.service';
import { Student } from '../../../../shared-components/student/student.model';
import { System } from '../../../../shared-components/System';
import { UserService } from '../../../../shared-components/user/user.service';
import { YearService } from '../../../../shared-components/year/year.service';
import { ProgramAndServiceDetail } from '../../../../student360/programs-and-services/programs-and-services-detail.model';
import { ProgramAndService } from '../../../../student360/programs-and-services/programs-and-services.model';
import { ProgramServiceConfig, Services } from '../../../district/models/program-service.model';
import { ProgramAndServiceService } from '../../program-and-service.service';
import { InvalidSelectionDialogComponent } from '../invalid-selection-dialog/invalid-selection-dialog.component';

@AutoUnsubscribe()
@Component({
    selector: 'app-add-edit-program-service-single-student',
    templateUrl: './add-edit-program-service-single-student.component.html',
    styleUrls: ['./add-edit-program-service-single-student.component.css']
})
export class AddEditProgramServiceSingleStudentComponent implements OnInit, OnDestroy {

    // Injected Properties
    header = 'Edit Program/Services';
    programAndService: ProgramAndService;
    addProgram: boolean;
    junkDateString = System.junkDateString;
    type = '';
    massEditProgramAndServices: ProgramAndService[] = [];
    // Local Properties
    selectedProgramCode: ProgramServiceConfig;
    selectedServiceCodeId: number;
    programCodes: ProgramServiceConfig[] = [];
    serviceCodes: Services[] = [];
    serviceFields: ProgramAndServiceDetail[] = [];
    originalProgram = new ProgramAndService();
    subscriptions: Subscription[] = [];
    errors: ErrorList[] = [];
    userCanEditPrograms = true;
    studentId = 0;
    invalidStudent: Student[] = [];
    selectedStudents: any;
    steps: boolean;
    showSteps = '';
    readOnly: boolean = false;
    @Input() okButtonLabel = 'Save';
    @Input() okButtonImage = 'save.png';
    @Input() backButtonLabel = 'Back';
    @Input() backButtonImage = 'previous arrow.png';
    @Output() previousEventaction = new EventEmitter();
    @Output() confirmEventAction = new EventEmitter();

    // Attachement properties
    dataSource: MatTableDataSource<Attachment> = new MatTableDataSource<Attachment>();
    displayedColumns = ['Description', 'UploadedOn', 'UploadedBy', 'Actions'];

    // View Properties
    @ViewChild('validationTrigger', { static: true }) validationTrigger: ElementRef;
    @ViewChild('programCodeField', { read: ElementRef }) programCodeField: ElementRef;
    @ViewChild('serviceCodeField', { read: ElementRef }) serviceCodeField: ElementRef;
    @ViewChild('entryDateField', { read: ElementRef }) entryDateField: ElementRef;
    confirmback = false;

    // Class Function
    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogBox: MatDialogRef<any, any>,
        private dialog: MatDialog,
        private yearService: YearService,
        private programsAndServicesService: ProgramAndServiceService,
        private userService: UserService,
        private sharedService: SharedService
    ) {
    }

    ngOnInit() {
        // Getting injected data
        if (this.data) {
            this.studentId = this.data.studentId ? this.data.studentId : 0;
            this.addProgram = this.data.addProgram;
            this.programCodes = _.cloneDeep(this.data.programCodes);
            this.programAndService = this.data.programAndService;
            this.selectedStudents = this.data.selectedStudents;
            this.showSteps = this.data.showSteps;
            this.steps = this.data.steps;

            if (this.addProgram) {
                this.header = 'Add Program/Services';
            }
            else {
                this.header = 'Edit Program/Services';
            }

            // Filter out Active program code with history
            this.programCodes = this.programCodes.filter(x => x.IsInActive == false);
            if (!this.addProgram) {
                if (this.programAndService.ProgramCodeId > 0) {
                    const selectedProgCode = this.data.programCodes.filter(p => p.Id == this.programAndService.ProgramCodeId.toString());
                    if (selectedProgCode && selectedProgCode.length > 0) {
                        if (!this.programCodes.find(p => p.Id == selectedProgCode[0].Id)) {
                            this.programCodes.push(selectedProgCode[0]);
                            this.programCodes = _.sortBy(this.programCodes, p => p.Code.toLowerCase() + '-' + p.Description.toLowerCase());
                        }
                    }
                }
            }
            if (this.data.type) {
                this.type = this.data.type;
            }
            if (this.data.massEditProgramAndServices && this.data.massEditProgramAndServices.length > 0) {
                this.massEditProgramAndServices = this.data.massEditProgramAndServices;
            }

            if (this.showSteps == null) {
                this.steps = false;
            }
            else {
                this.steps = true;
            }

            this.getProgramServiceCodesByUserId();


            // Intialize the values
            if (!this.programAndService.Attachments) {
                this.programAndService.Attachments = [];
            }
            if (this.programAndService.EntryDate && this.programAndService.EntryDate.toString() == System.junkDate.toString()) {
                this.programAndService.EntryDate = null;
            }
            if (this.programAndService.ExitDate && this.programAndService.ExitDate.toString() == System.junkDate.toString()) {
                this.programAndService.ExitDate = null;
            }

            // Setting up the local data
            Object.assign(this.originalProgram, this.programAndService);
            this.dataSource.data = this.programAndService.Attachments;
            this.dataSource.filterPredicate = (data: Attachment, filter: string) => (data.Deleted == null || data.Deleted == false);
        }
    }

    ngOnDestroy() {

    }

    getProgramServiceCodesByUserId() {
        this.programsAndServicesService.getProgramServiceCodesByUserId(this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID).subscribe(result => {
            this.programCodes = result.filter(o => o.UserHasEditPermission == true);

            if (this.programAndService.ProgramCodeId != null && this.programAndService.ProgramCodeId > 0) {
                this.selectedProgramCode = this.programCodes.find(o => o.Id == this.programAndService.ProgramCodeId || o.Code == this.programAndService.ProgramCodeId.toString());
                this.onProgramCodeChange(true);
            }
        });
    }

    backClick() {
        if (this.confirmback == true) {
            const ps = this.data.programAndService;
            const service = this.serviceCodes.filter(o => o.Id == this.selectedServiceCodeId)[0];
            const programcode = this.selectedProgramCode ? this.selectedProgramCode.Code : '';
            const serviceCode = service ? service.Code : '';
            const selectedprog = this.selectedProgramCode ? this.selectedProgramCode.Code + '-' + this.selectedProgramCode.Description : '';
            const selectedser = service ? service.Code + '-' + service.Description : '';
            const itemMenu = { itemName: 'General Confirmation', selectedStudents: this.data.selectedStudents, programCodes: selectedprog, programService: selectedser, programcode, serviceCode, ps };
            this.dialogBox.close(itemMenu);
        }

        if (this.confirmback == false) {
            const itemMenu = { itemName: 'Mass Enroll Into Service', selectedStudents: this.data.selectedStudents };
            this.dialogBox.close(itemMenu);
        }
    }

    onProgramCodeChange(init = false) {
        this.programAndService.ProgramCodeId = 0;
        if (init == false) {
            this.programAndService.ServiceCodeId = 0;
        }
        if (this.selectedProgramCode) {
            this.programAndService.ProgramCodeId = this.selectedProgramCode.Id;
            const serviceCodeId = this.programAndService.ServiceCodeId != null ? this.programAndService.ServiceCodeId : 0;
            this.serviceCodes = this.selectedProgramCode.ProgramServices.filter(o => o.Id == serviceCodeId || o.Inactive == false);
            if (serviceCodeId > 0) {
                this.selectedServiceCodeId = serviceCodeId;
            }
            this.getServiceFieldByServiceCodeId(this.programAndService.ServiceCodeId, this.programAndService.id, init);
        }
    }

    onServiceCodeChange() {
        // PRE: Initialize service codes
        // POST: populate the associated field on changed
        if (this.selectedServiceCodeId != null && this.selectedServiceCodeId > 0) {
            this.programAndService.ServiceCodeId = this.selectedServiceCodeId;
        } else {
            this.programAndService.ServiceCodeId = 0;
        }
        this.getServiceFieldByServiceCodeId(this.programAndService.ServiceCodeId, this.programAndService.Id);
    }

    getServiceFieldByServiceCodeId(serviceCodeId: number, programAndServiceId: number, init: boolean = false) {
        // POST: Get ServiceFields associated to service from server
        this.programAndService.ProgramAndServicesDetail = [];
        this.subscriptions.push(
            this.programsAndServicesService.getServiceDetailByServiceCodeId(serviceCodeId, programAndServiceId).subscribe(res => {
                this.programAndService.ProgramAndServicesDetail = res;
                if (init) {
                    this.programAndService.ProgramAndServicesDetail.forEach(detail => {
                        const originalFieldValue = this.originalProgram.ProgramAndServicesDetail ? this.originalProgram.ProgramAndServicesDetail.find(o => o.FieldId == detail.FieldId) : null;
                        if (originalFieldValue) {
                            detail.FieldType = originalFieldValue.FieldType;
                            detail.FieldValue = originalFieldValue.FieldValue;
                            detail.FieldValueId = originalFieldValue.FieldValueId;
                            detail.ProgramServiceField = originalFieldValue.ProgramServiceField;
                        }
                    });
                } else {
                    this.programAndService.ProgramAndServicesDetail = res;
                }
            })
        );
    }

    setCurrent(value: string) {
        // POST: The Entry/Exit date to current date
        const date = new Date();
        const datePart = moment(date).format('MM-DD-YYYY');
        if (value == 'EntryDate') {
            this.programAndService.EntryDate = moment(datePart, 'MM-DD-YYYY').toDate();
        }
        else if (value == 'ExitDate') {
            this.programAndService.ExitDate = moment(datePart, 'MM-DD-YYYY').toDate();
        }
    }

    cancel() {
        // for mass enroll cancel passing selected student to uncheck
        const itemMenu = { itemName: 'Mass Enroll Into Service Cancel', selectedStudents: this.data.selectedStudents };
        // PRE: the cancel button is clicked
        // POST: resets the program and closes the dialog box
        if (!this.addProgram) {
            Object.assign(this.programAndService, this.originalProgram);

        }
        this.dialogBox.close(itemMenu);
    }

    // Atachemnt methods

    deleteAttachmentClick(attachment: Attachment) {
        // PRE: Attachement grid is intialized
        // POST: Set attachemnt.Deleted to true and remove the row from grid
        const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
            disableClose: true,
        });
        deleteConfirmDialog.componentInstance.headerLabel = 'Delete Attachment';
        deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete ' + attachment.AttachmentFileName + '?';
        deleteConfirmDialog.componentInstance.okButtonLabel = 'Delete';
        deleteConfirmDialog.componentInstance.confirmEvent.subscribe((confirmed: boolean) => {
            if (confirmed) {
                if (attachment.AttachmentId && attachment.AttachmentId > 0) {
                    attachment.Deleted = true;
                } else {
                    const index = this.programAndService.Attachments.indexOf(attachment);
                    if (index > -1) {
                        this.programAndService.Attachments.splice(index, 1);
                    }
                }
                this.dataSource.data = this.programAndService.Attachments.filter(o => o.Deleted == false);
            }
        });
    }

    attachmentClick = (attachment: Attachment) => {
        // PRE: Attachement grid is intialized
        // POST: View or download the attachemnt
        // System.viewFileFromId(attachment.AttachmentId, attachment.AttachmentFileName);

        if (attachment.MyFileBase64String && attachment.AttachmentFileName && attachment.FileType) {
            System.viewFileFromBase(attachment.MyFileBase64String, attachment.FileType, attachment.AttachmentFileName);
        } else if (attachment.AttachmentId && attachment.AttachmentFileName) {
            System.viewFileFromId(attachment.AttachmentId, attachment.AttachmentFileName);
        }
    }

    addAttachmentClick() {
        // POST: opens a modal to add an attachment

        // Initializing attachment
        const attachment = new Attachment();
        attachment.AttachmentId = -(this.programAndService.Attachments.length + 1);
        attachment.FileType = '';
        attachment.FileExtension = '';
        attachment.Description = '';
        attachment.AttachmentFileName = '';
        attachment.OriginalFileName = '';
        attachment.AttachmentAddedOn = new Date();
        attachment.AttachmentDescription = '';

        // Opening modal
        const dialogBox = this.dialog.open<AddAttachmentDialogComponent>(AddAttachmentDialogComponent, {
            data: {
                attachment: attachment,
                newAttachment: true
            },
            disableClose: true
        });
        this.subscriptions.push(
            dialogBox.afterClosed().subscribe(() => {
                if (dialogBox.componentInstance.saved) {
                    attachment.AttachmentDescription = attachment.Description;
                    attachment.AttachmentFileName = attachment.FileName;
                    attachment.DocumentBase64 = attachment.MyFileBase64String;
                    attachment.AttachmentFileMimeType = attachment.FileType;
                    attachment.AttachmentAddedBy = this.userService.currentUser.LastName + ', ' + this.userService.currentUser.FirstName;
                    this.programAndService.Attachments.push(attachment);
                    this.dataSource.data = this.programAndService.Attachments;
                }
            })
        );
    }

    editAttachmentClick(att: Attachment) {
        // POST: opens a modal to add an attachment

        // Initializing attachment
        const attachment = new Attachment();
        attachment.AttachmentId = att.AttachmentId;
        attachment.FileType = att.AttachmentFileMimeType;
        attachment.FileExtension = att.FileExtension;
        attachment.Description = att.AttachmentDescription;
        attachment.FileName = att.AttachmentFileName;
        attachment.DocumentTypeId = 0;
        attachment.MyFileBase64String = att.MyFileBase64String;
        attachment.AttachmentAddedOn = new Date();

        // Opening modal
        const dialogBox = this.dialog.open<AddAttachmentDialogComponent>(AddAttachmentDialogComponent, {
            data: {
                attachment: attachment,
                newAttachment: false,
                editAttachment: true
            },
            disableClose: true
        });
        this.subscriptions.push(
            dialogBox.afterClosed().subscribe(() => {
                if (dialogBox.componentInstance.saved) {
                    attachment.AttachmentDescription = attachment.Description;
                    attachment.AttachmentFileName = attachment.FileName;
                    attachment.DocumentBase64 = attachment.MyFileBase64String;
                    attachment.AttachmentFileMimeType = attachment.FileType;
                    attachment.AttachmentAddedBy = this.userService.currentUser.LastName + ', ' + this.userService.currentUser.FirstName;

                    const at = this.programAndService.Attachments.find(x => x.AttachmentId == attachment.AttachmentId);
                    const idx = this.programAndService.Attachments.indexOf(at);
                    this.programAndService.Attachments[idx] = attachment;
                    // this.programAndService.Attachments.push(attachment);
                    this.dataSource.data = this.programAndService.Attachments;
                }
            })
        );
    }

    // Save

    // Save functions
    save() {
        // PRE: the save button is clicked
        // POST: saves the program and closes the dialog box
        // NOTE: closing with true here means there are new program and service record
        this.validationTrigger.nativeElement.click();
        this.validate();
        if (this.errors.length == 0) {

            // Add/Edit a program
            if (this.programAndService) {
                if (this.type == 'MassAdd') {
                    this.massAddProgramAndService();
                }
                else if (this.type == 'MassEdit') {
                    this.massEditProgramAndService();
                }
                else if (this.type == 'Mass Enroll Into Service') {
                    this.confirmback = true;
                    this.backClick();
                }
                else {
                    this.subscriptions.push(this.programsAndServicesService.saveProgramAndService(this.studentId, this.programAndService).subscribe(
                        () => {
                            this.dialogBox.close(true);
                        }
                    ));
                }
            }
        }
    }

    private massAddProgramAndService() {
        // PRE: the save button is clicked
        // POST: Mass add the program and service and closes the dialog box
        // validate student
        this.invalidStudent = [];
        this.programsAndServicesService.getInvalidStudentForSelectedProgramAndServiceCode(this.programAndService).subscribe(result => {
            if (result && result.length > 0) {
                this.invalidStudent = result;
                result.forEach(s => {
                    this.programAndService.Students = this.programAndService.Students.filter(o => o.Id != s.Id);
                });
            }

            // save program and service
            if (this.programAndService.Students.length > 0) {
                this.programsAndServicesService.massAddProgramAndService(this.programAndService).subscribe(res => {
                    if (res && res != '' && res == 'Successful') {
                        // open popup if there is invalid student selection found
                        if (!this.invalidStudent || this.invalidStudent.length == 0) {
                            this.dialogBox.close(true);
                        }
                    }
                });
            }

            if (this.invalidStudent && this.invalidStudent.length > 0) {
                const dialogBoxInvalidSelection = this.dialog.open<InvalidSelectionDialogComponent>(InvalidSelectionDialogComponent, {
                    data: {
                        invalidStudent: this.invalidStudent,
                    },
                    disableClose: true
                });
                this.subscriptions.push(
                    dialogBoxInvalidSelection.afterClosed().subscribe(dialogResult => {
                        this.programAndService.Students = this.invalidStudent;
                        if (dialogResult == 2) {
                            this.programsAndServicesService.massAddProgramAndService(this.programAndService).subscribe(() => {
                                this.dialogBox.close(true);
                            });
                        }
                    })
                );
            }
        });
    }

    private massEditProgramAndService() {
        // PRE: the save button is clicked
        // POST: Mass add the program and service and closes the dialog box
        const fieldDetails: ProgramAndServiceDetail[] = [];
        this.programAndService.ProgramAndServicesDetail.forEach(ps => {
            const field = new ProgramAndServiceDetail();
            field.FieldName = ps.FieldName;
            field.FieldValue = ps.FieldValue;
            field.Id = ps.Id;
            field.Sequence = ps.Sequence;
            field.ProgramServiceField = ps.ProgramServiceField;
            field.FieldType = ps.FieldType;
            field.FieldLookupValues = ps.FieldLookupValues;
            field.FieldValueId = ps.FieldValueId;
            field.FieldId = ps.FieldId;
            field.FieldLength = ps.FieldLength;
            field.FieldDecimal = ps.FieldDecimal;
            fieldDetails.push(field);
        });

        this.massEditProgramAndServices.forEach(ps => {
            ps.ProgramCodeId = _.cloneDeep(this.programAndService.ProgramCodeId);
            ps.ServiceCodeId = _.cloneDeep(this.programAndService.ServiceCodeId);
            ps.EntryDate = _.cloneDeep(this.programAndService.EntryDate);
            ps.ExitDate = _.cloneDeep(this.programAndService.ExitDate);
            ps.ProgramAndServicesDetail = _.cloneDeep(fieldDetails);
        });

        // Save program and service
        this.subscriptions.push(this.programsAndServicesService.massEditProgramAndService(this.massEditProgramAndServices).subscribe(res => {
            if (res && res != '' && res == 'Successful') {
                // Open popup if there is invalid student selection found
                this.dialogBox.close(true);
            }
        }));
    }

    validate() {
        // POST: sets the errors
        this.errors = [];

        // Program Code is required
        if (!this.programAndService.ProgramCodeId || this.programAndService.ProgramCodeId <= 0) {
            this.errors.push({
                fieldName: 'Program',
                fieldRef: this.programCodeField,
                errorMsg: 'Required field.'
            });
        }

        // Service Code is required
        if (!this.programAndService.ServiceCodeId || this.programAndService.ServiceCodeId <= 0) {
            this.errors.push({
                fieldName: 'Service',
                fieldRef: this.serviceCodeField,
                errorMsg: 'Required field.'
            });
        }

        // Entry Date is required
        if (!this.programAndService.EntryDate || this.programAndService.EntryDate.toString() == System.junkDate.toString()) {
            this.errors.push({
                fieldName: 'Entry Date',
                fieldRef: this.entryDateField,
                errorMsg: 'Required field.'
            });
        }

    }

}
